import { Overmind } from 'overmind';
import { Context } from '../index';
import Constants from '../../../app.constants';

export const onInitializeOvermind = (context: Context, instance: Overmind<Context>) => {
  // context.effects.api.initialize({
  //   clientOptions: {
  //     httpUrl: Constants.HOST,
  //     getJWT: () => context.state.auth.jwt,
  //     refreshJWT: context.actions.api.refreshToken,
  //     clearJWT: context.actions.api.clearToken,
  //   },
  // });
};

export const refreshToken = (context: Context) => {
  let token: string | null = null;
  try {
    return context.effects.api.getNewAccessToken().then((data: any) => {
      token = data?.getNewAccessToken.token || context.state.auth.jwt;

      context.actions.auth.setJwt(token);

      console.info('refreshJWT.success');
    });
  } catch (e) {
    console.error('refreshJWT.error', e);
  }

  return token;
};

export const clearToken = async (context: Context) => {
  try {
    // TODO: apparently this does nothing as of 7/6/2021
    // const { data } = await effects.api.logout();
    context.actions.auth.setJwt(null);
    context.actions.session.removeFromStorage();

    return null;
  } catch (e) {
    console.error('clearToken.error', e);
    return e;
  }
};
